import { Injectable } from '@angular/core';
import { Observable, throwError,of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpClientService } from '../http-client.service';
import { UserService } from './user.service';
import { environment } from '../../environments/environment';
import { IUser, IUserAlignmentFromAPI } from './interfaces/app.interface';
import * as _ from 'lodash';
import { HttpErrorResponse } from '@angular/common/http';
import { ApplicationInsightsService } from '../shared/application-insights.service';
import { appVariables } from '../app.constants';
import { MsalService } from '@azure/msal-angular';
import { AuthError, IPublicClientApplication, PublicClientApplication } from '@azure/msal-browser';



//const msalInstance = new PublicClientApplication(msalConfig);
@Injectable({ providedIn: 'root' })
export class AuthService {
 
  private readonly restApiURL: string;
  private readonly restApiURL_new: string;

  
  

  constructor(private msalService: MsalService, private httpClientService: HttpClientService,
              private userService: UserService, private applicationInsightsService: ApplicationInsightsService) {
    this.restApiURL = environment.apiHost;
    this.restApiURL_new = environment.apiHost_new;

   
  }
   checkBetaUser(email: string): Observable<{ isBetaUser: boolean }> {
    if (!email) {
      return of({ isBetaUser: false }); // Return false if no email
    }
    // We use httpClientService here, assuming it's your wrapper that adds auth tokens
    return this.httpClientService.get<{ isBetaUser: boolean }>(
      `${this.restApiURL_new}/beta-users/check/${email}`
    ).pipe(
      catchError((error: HttpErrorResponse) => {
        console.error('Beta user check failed, returning false', error);
        // If the API fails (e.g., 404, 500), safely treat them as not a beta user.
        return of({ isBetaUser: false });
      })
    );
  }


  authenticateUser(loggedInEmail: string, isImpersonating: boolean): Observable<any> {
    this.userService.isAuthenticatingUser = true;
    const effectiveEmail = loggedInEmail || 'empty';

    const url = isImpersonating
      ? `${this.restApiURL_new}/territory-order/territories?impersonate=${effectiveEmail}`
      : `${this.restApiURL_new}/territory-order/territories`;

    return this.httpClientService.get<IUserAlignmentFromAPI>(url).pipe(
      map((response: IUserAlignmentFromAPI) => {
        this.userService.currentUser = this.covertUserAlignmentFromAPI(effectiveEmail, response);
        this.userService.isAuthenticatingUser = false;
      }),
      catchError((error: HttpErrorResponse) => {
        console.log('authenticateUser', error);
        this.applicationInsightsService.trackExceptions(error);
        return throwError(error);
      }),
    );
  }

  
  
  private covertUserAlignmentFromAPI(loggedInEmail: string, userAlignmentRes: IUserAlignmentFromAPI): IUser {
    const userDetails = {} as IUser;
    userDetails.email = loggedInEmail;

    if (sessionStorage.getItem(appVariables.guids.paramGUID) && sessionStorage.getItem(appVariables.guids.searchGUID)) {
      userDetails.isTerritoryManager = false;
    } else if (userAlignmentRes.territories && userAlignmentRes.territories.length > 0) {
      userDetails.isTerritoryManager = true;
      userDetails.territories = _.cloneDeep(userAlignmentRes.territories);
    } else {
      userDetails.isTerritoryManager = false;
    }

    return userDetails;
  }



getMsalInstance(): IPublicClientApplication {
  return this.msalService.instance;
}



}

